import {apiCall} from "../../../_utils";
import {apiUrls} from "../../../_constants";

export const upLoadService = {
    submitImage,
  };

  function submitImage(request) {
    return apiCall("POST", `${apiUrls.posts.uploadImage}`, request);
  }